<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('enrolments.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-btn class="darken-2 ma-0 mr-2" color="success" v-if="selectedEnrolments.length > 0" @click.stop="multienrcourselistpopup_show">
        <v-icon small>fas fa-plus</v-icon>
        <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("enrolments.enrol") }}</span>
      </v-btn>

      <v-layout row wrap v-if="$vuetify.breakpoint.smAndUp">
        <v-flex xs12>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex :xs3="$vuetify.breakpoint.mdAndUp" :xs6="$vuetify.breakpoint.smOnly" :xs12="$vuetify.breakpoint.xsOnly">
                <v-text-field
                  :label="$t('enrolments.search')"
                  v-model="search_params.any"
                  @keydown="checkKeyPress"
                  hide-details
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex :xs3="$vuetify.breakpoint.mdAndUp" :xs6="$vuetify.breakpoint.smOnly" v-if="$vuetify.breakpoint.smAndUp">
                <v-select
                  v-model="search_params.status_text"
                  :items="$dd_enrolment_list_status()"
                  item-text="text"
                  item-value="key"
                  :label="$t('enrolments.status')"
                  @change="filter"
                  hide-details
                >
                </v-select>
              </v-flex>

              <v-flex xs3 v-if="$vuetify.breakpoint.mdAndUp">
                <v-select
                  v-model="search_params.coursetype_id"
                  :items="coursetypes"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypes.title')"
                  @change="filter"
                  hide-details
                  clearable
                >
                </v-select>
              </v-flex>

              <v-flex xs3 v-if="$vuetify.breakpoint.mdAndUp">
                <v-select
                  v-model="search_params.course_id"
                  :items="courses"
                  item-text="custom_name_1"
                  item-value="id"
                  :label="$t('courses.title')"
                  @change="filter"
                  hide-details
                  clearable
                >
                </v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>

      <action-button type="filter" @click="show_filter = !show_filter" :icon_only="true" v-if="$vuetify.breakpoint.xsOnly" />
    </v-app-bar>

    <!-- MOBILE SEARCH -->
    <v-expansion-panels :value="0" class="cstm-filter mb-3 elevation-0" v-if="show_filter && $vuetify.breakpoint.xsOnly">
      <v-expansion-panel>
        <v-expansion-panel-content class="elevation-1">
          <v-form ref="form" @submit.prevent="filter">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('enrolments.search')"
                    v-model="search_params.any"
                    @keydown="checkKeyPress"
                    hide-details
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="search_params.status_text"
                    :items="$dd_enrolment_list_status()"
                    item-text="text"
                    item-value="key"
                    :label="$t('enrolments.status')"
                    @change="filter"
                    hide-details
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="enrolments"
            :items-per-page="enrolments.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            item-key="id"
            :show-select="true"
            v-model="selectedEnrolments"
            :must-sort="true"
          >
            <template v-slot:item.last_name="{ item }">
              {{ item.last_name }}
              <router-link
                :to="{ path: BACKEND_URL + '/courses/edit/' + item.course_id, query: { autoOpenEnrolment: item.id } }"
                class="enable-internal-note"
              >
                <v-icon class="ml-3" color="black" small v-if="item.internal_notes && item.course_id">fas fa-comment</v-icon>
              </router-link>
            </template>

            <template v-slot:item.status="{ item }">
              {{ $dd_enrolment_status(item.status) }}
            </template>

            <template v-slot:item.course_id="{ item }">
              {{ item.course.name }}
            </template>

            <template v-slot:item.enrolment_organisation_id="{ item }">
              {{ item.organisation.name }}
            </template>

            <template v-slot:item.start_date="{ item }">
              {{ item.course.start_date ? moment.utc(item.course.start_date).format(DATE_FORMAT) : null }}
            </template>

            <template v-slot:item.course_type="{ item }">
              {{ item.course.course_type }}
            </template>

            <template v-slot:item.course_full_address="{ item }">
              {{ item.course.course_full_address }}
            </template>

            <template v-slot:item.actions="{ item }">
              <!--<action-button
                type="add_to_participant"
                :icon_only="true"
                @click="openCourseListPopup(item.id, item.coursetype_id)"
                v-if="$can('participant-access') && (item.status != 4) && !item.course_id"
                small
              />-->

              <action-button type="view" :icon_only="true" @click="viewEnrolment(item.id)" small />

              <action-button type="add_to_participant" :icon_only="true" @click="showMoveEnrolment(item.id)" small />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showRemoveEnrolmentModal" persistent max-width="480px">
      <div class="form-modal pa-4">
        <p>{{ $t("courses.move_enrolment") }}</p>
        <action-button
          type="cancel"
          @click="moveEnrolment('interested-list')"
          class="d-block mb-2"
          :icon="null"
          :text="$t('courses.move_enrolment_interested_list')"
        />
        <action-button
          type="cancel"
          @click="moveEnrolment('another-course')"
          class="d-block mb-2"
          :icon="null"
          :text="$t('courses.move_enrolment_another_course')"
        />
        <action-button
          type="cancel"
          color="error"
          @click="del(selectedEnrolmentId)"
          class="d-block mb-2"
          :icon="null"
          :text="$t('courses.delete_enrolment')"
        />
        <action-button type="cancel" color="error" @click="hideMoveEnrolment" :icon="null" class="d-block" />
      </div>
    </v-dialog>

    <courseListPopup
      :show="showCourseListPopup"
      :single_select="false"
      :status_ids="[1]"
      :title="$t('enrolments.select_course_title')"
      :coursetype_id="selectedCourseTypeId"
      @callback_courselistpopup_cancel="callback_courselistpopup_cancel"
      @callback_courselistpopup_submit="callback_courselistpopup_submit"
    />

    <courseListPopup
      :title="$t('courses.title')"
      :show="showEnrMoveCourseListPopup"
      :coursetype_id="selectedCourseTypeId"
      :status_ids="[1]"
      :single_select="true"
      :show_course_filter="false"
      :show_coursetype_filter="true"
      @callback_courselistpopup_cancel="callback_enrmovecourselistpopup_cancel"
      @callback_courselistpopup_submit="callback_enrmovecourselistpopup_submit"
    />

    <courseListPopup
      :show="showMultiEnrCourseListPopup"
      :title="$t('enrolments.select_course_title')"
      :status_ids="[1]"
      @callback_courselistpopup_cancel="callback_multienrcourselistpopup_cancel"
      @callback_courselistpopup_submit="callback_multienrcourselistpopup_submit"
    />
  </v-container>
</template>

<script>
import courseListPopup from "../../courses/partials/CourseListPopup.vue"

export default {
  name: "EnrolmentsList",

  components: {
    courseListPopup
  },

  data() {
    return {
      //param_enrId: 0,

      url: "",
      enrolments: [],
      all_courses: [],
      courses: [],
      coursetypes: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__enrolmentListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["first_name"],
        sortDesc: [false]
      },
      search_params: {
        status: 1,
        any: "",
        course_id: this.$route.query.course_id ? Number(this.$route.query.course_id) : "",
        status_text: this.$route.query.course_id ? "all" : this.$getDefaultDropdown(this.$dd_enrolment_list_status())
      },

      showCourseListPopup: false,
      selectedEnrolmentId: null,
      selectedCourseTypeId: null,

      showRemoveEnrolmentModal: false,
      showEnrMoveCourseListPopup: false,

      selectedEnrolments: [],
      showMultiEnrCourseListPopup: false
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("enrolments.status"), value: "status" },
          { text: this.$t("enrolments.p_first_name"), value: "first_name", width: "11%" },
          { text: this.$t("enrolments.p_last_name"), value: "last_name", width: "11%" },
          { text: this.$t("enrolments.p_email"), value: "email" },
          { text: this.$t("enrolments.o_name"), value: "enrolment_organisation_id", width: "11%" },
          { text: this.$t("courses.type"), value: "course_type", width: "9%" },
          { text: this.$t("courses.start_date"), value: "start_date" },
          { text: this.$t("courses.address_title"), value: "course_full_address" },
          { text: this.$t("enrolments.course"), value: "course_id" },
          {
            text: this.breakpointXsOnly ? "" : this.$t("global.actions"),
            value: "actions",
            width: "20%",
            align: "end",
            sortable: false,
            class: "textclass"
          }
        ]
      }
    },
    breakpointXsOnly() {
      return this.$vuetify.breakpoint.xsOnly
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          localStorage.setItem("__enrolmentListSearchParams", JSON.stringify(this.search_params))
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__enrolmentListSort", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__enrolmentListPage", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "enrolments"

    if (localStorage.getItem("__enrolmentListSearchParams")) {
      this.search_params = JSON.parse(localStorage.getItem("__enrolmentListSearchParams"))
    }
  },

  methods: {
    list() {
      this.show_loading = true

      this.search_params.status = ""

      switch (this.search_params.status_text) {
        case "request":
          this.search_params.status = 3
          break
        case "cancelled":
          this.search_params.status = 4
          break
        case "active":
          this.search_params.status = 1
          break
      }

      let localSort = localStorage.getItem("__enrolmentListSort")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?resourcetype=enrolment-list&" + query).then((res) => {
        this.enrolments = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false
        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)

        this.loadCourse()
      })
    },

    loadCourse() {
      axios.get(this.API_URL + "course/query?action=get-courses-with-enrolled-and-future-courses").then((res) => {
        let ids = res.data
        let query_course_statuses = ""

        if (this.search_params.status_text == "active") {
          query_course_statuses = "&query_statuses=1,2,4,5"
        } else if (this.search_params.status_text == "cancelled") {
          query_course_statuses = "&query_statuses=0,3"
        }

        let lists = [
          { key: "courses", module: "courses", query: "show_all=true&query_ids=" + ids.join(",") + query_course_statuses },
          { key: "coursetypes", module: "coursetypes", query: "show_all=true" }
        ]

        axios
          .post(this.API_URL + "request/ddlists", lists)
          .then((res) => {
            this.all_courses = res.data.courses

            if (this.search_params.coursetype_id) {
              this.courses = this.all_courses.filter((i) => i.coursetype_id == this.search_params.coursetype_id)
            } else {
              this.courses = this.all_courses
            }

            this.coursetypes = res.data.coursetypes
          })
          .catch((err) => console.log(err))
      })
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    /*verify(id) {
            this.param_enrId = id;
        },*/

    del(id = null) {
      let vm = this

      if (id) {
        this.$awn.confirm(
          this.$t("global.delete_message"),
          () => {
            return
          },
          () => {
            axios
              .delete(this.API_URL + "enrolment/" + id)
              .then((res) => {
                vm.callback_enrmovecourselistpopup_cancel()
                vm.hideMoveEnrolment()
                vm.refresh = true
                vm.$awn.success(vm.$t("global.delete_success"))
              })
              .catch((err) => console.log(err))
          },
          {
            labels: {
              confirm: "",
              confirmCancel: this.$t("global.yes"),
              confirmOk: this.$t("global.no")
            }
          }
        )
      }
    },

    convertToParticipant(id, cid) {
      let vm = this

      axios
        .post(this.API_URL + "participant/convert", {
          id: id,
          courseid: cid
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            if (res.data.data.id) {
              vm.$awn.success(vm.$t("enrolments.add_to_participant_success"))
            } else {
              vm.$awn.alert(vm.$t("enrolments.add_to_participant_error"))
            }

            vm.refresh = true
          }
        })
        .catch((err) => {
          if ((err.response.status = 451)) {
            vm.$awn.alert(vm.$t("enrolments.already_enrolled"))
            vm.refresh = true
          }
        })
    },

    convertActiveEnrolment(id, cids, keep_interest) {
      let vm = this

      axios
        .post(this.API_URL + "enrolment/enrolmenetRequestToActiveEnrolment", {
          id: id,
          course_ids: cids,
          keep_interest: keep_interest
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            if (res.data.data.id) {
              vm.$awn.success(vm.$t("enrolments.single_enrolment_successful"))
            } else {
              vm.$awn.alert(vm.$t("enrolments.single_enrolment_failed"))
            }

            vm.refresh = true
          }
        })
        .catch((err) => {
          if ((err.response.status = 451)) {
            vm.$awn.alert(vm.$t("enrolments.already_enrolled"))
            vm.refresh = true
          }
        })

      this.callback_courselistpopup_cancel()
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    },

    openCourseListPopup(id, ct) {
      this.selectedEnrolmentId = id
      this.selectedCourseTypeId = ct
      this.showCourseListPopup = true
    },
    callback_courselistpopup_cancel() {
      this.showCourseListPopup = false
      this.selectedEnrolmentId = null
      this.selectedCourseTypeId = null
    },
    callback_courselistpopup_submit(courses) {
      if (courses.length > 0) {
        let cids = courses.map((a) => a.id).join(",")
        let enr = this.enrolments.find((i) => i.id == this.selectedEnrolmentId)

        if (enr) {
          if (enr.mode == "interest") {
            this.$awn.confirm(
              this.$t("fe.enrolment.interest_enrol_confirm"),
              () => {
                this.convertActiveEnrolment(this.selectedEnrolmentId, cids, true)
              },
              () => {
                this.convertActiveEnrolment(this.selectedEnrolmentId, cids, false)
              },
              {
                labels: {
                  confirmOk: this.$t("global.yes"),
                  confirmCancel: this.$t("global.no")
                }
              }
            )
          } else {
            this.convertActiveEnrolment(this.selectedEnrolmentId, cids, false)
          }
        }
      }
    },

    showMoveEnrolment(id) {
      this.selectedEnrolmentId = id
      this.showRemoveEnrolmentModal = true
    },
    hideMoveEnrolment() {
      this.selectedEnrolmentId = null
      this.selectedCourseTypeId = null
      this.showRemoveEnrolmentModal = false
    },
    moveEnrolment(type) {
      let vm = this
      let enrolment = this.enrolments.find((i) => i.id == this.selectedEnrolmentId)

      if (enrolment) {
        if (type == "interested-list") {
          axios
            .post(this.API_URL + "enrolment/moved-interestedlist", {
              id: this.selectedEnrolmentId,
              course_id: enrolment.course_id
            })
            .then((res) => {
              vm.$awn.success(vm.$t("courses.move_enrolment_interested_list_success"))
              vm.hideMoveEnrolment()
              vm.refresh = true
            })
            .catch((err) => {
              vm.$awn.success(vm.$t("courses.move_enrolment_interested_list_failed"))
            })
        }

        if (type == "another-course") {
          this.selectedCourseTypeId = enrolment.coursetype_id
          this.enrmovecourselistpopup_show()
        }
      } else {
        this.hideMoveEnrolment()
      }
    },
    enrmovecourselistpopup_show() {
      this.showEnrMoveCourseListPopup = true
    },
    callback_enrmovecourselistpopup_submit(data) {
      let ids = data.map((i) => i.id)
      let id = ids.shift()
      let vm = this

      if (id) {
        axios
          .post(this.API_URL + "enrolment/moved-anothercourse", {
            id: this.selectedEnrolmentId,
            course_id: id
          })
          .then((res) => {
            vm.$awn.success(vm.$t("courses.move_enrolment_another_course_success"))
            vm.callback_enrmovecourselistpopup_cancel()
            vm.hideMoveEnrolment()
            vm.refresh = true
          })
          .catch((err) => {
            vm.$awn.success(vm.$t("courses.move_enrolment_another_course_failed"))
            vm.callback_enrmovecourselistpopup_cancel()
          })
      } else {
        vm.callback_enrmovecourselistpopup_cancel()
      }
    },
    callback_enrmovecourselistpopup_cancel() {
      this.showEnrMoveCourseListPopup = false
      this.hideMoveEnrolment()
    },

    multienrcourselistpopup_show() {
      this.showMultiEnrCourseListPopup = true
    },
    callback_multienrcourselistpopup_submit(data) {
      this.callback_multienrcourselistpopup_cancel()

      let vm = this
      let enrolment_ids = this.selectedEnrolments.map((i) => i.id)
      let course_ids = data.map((i) => i.id)

      axios
        .post(this.API_URL + "enrolment/multiEnrolment", {
          enrolment_ids: enrolment_ids.join(","),
          course_ids: course_ids.join(",")
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            vm.$awn.success(vm.$t("enrolments.multi_enrolment_successful"))
          }

          vm.selectedEnrolments = []
          vm.refresh = true
        })
        .catch((err) => console.log(err))
    },
    callback_multienrcourselistpopup_cancel() {
      this.showMultiEnrCourseListPopup = false
    },
    viewEnrolment(id) {
      this.$router.push(this.BACKEND_URL + "/enrolments/view/" + id)
    }
  }
}
</script>

<style>
.v-data-table-header-mobile tr th {
  padding: 0 !important;
}
.v-data-table__mobile-table-row .v-data-table__mobile-row:nth-child(11) {
  height: auto !important;
  padding-bottom: 4px;
}
</style>
